import type { DeliveryState } from '@/store/delivery/delivery.types'

import { StateGeoAddress } from '@/types/mapServices'

export const DEFAULT_DELIVERY: DeliveryState = {
  areas: [],
  points: [],
  page: {
    seo: {
      description: undefined,
      title: undefined,
      keywords: undefined,
    },
    title: null,
    pointFilters: [],
    breadcrumbs: [],
    noticeText: null,
    additives: [],
    attentionFactoid: {
      text: null,
      title: null,
    },
  },
  activeTags: [],
  coordinates: [0, 0],
  deliveryAddress: {
    address: {
      place: null,
      address: null,
    },
    details: null,
    state: StateGeoAddress.READY,
    coordinates: [0, 0],
  },
  isLoadingAreas: false,
}
